<script setup>
import { init, use } from 'echarts/core'
import { SVGRenderer } from 'echarts/renderers'
import { BarChart } from 'echarts/charts'
import { GridComponent } from 'echarts/components'
import { onBeforeUnmount, onMounted, ref } from 'vue'

const props = defineProps(['title', 'xaxis', 'yaxis', 'label'])
const chartContainer = ref(null)
let chartInstance = null

use([
  SVGRenderer,
  BarChart,
  GridComponent
])

const initChart = () => {
  if(chartContainer.value) {
    chartInstance = init(chartContainer.value)

    chartInstance.setOption({
      xAxis: {
        data: JSON.parse(props.xaxis),
        axisTick: {
          alignWithLabel: true
        },
        axisLabel: {
          rotate: 45
        },
      },
      yAxis: {
        name: props.title
      },
      series: [
        {
          name: props.label,
          type: 'bar',
          data: JSON.parse(props.yaxis)
        }
      ]
    })
  }
}

const handleResize = () => {
  if(chartInstance) {
    chartInstance.resize()
  }
}

const disposeChart = () => {
  if(chartInstance) {
    chartInstance.dispose()
  }
  chartInstance = null
  chartContainer.value = null
}

onMounted(() => {
  initChart()
  window.addEventListener('resize', handleResize)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize)
  disposeChart()
})
</script>

<template>
  <div v-if="props.xaxis.length > 2 && props.yaxis.length > 2" class="barchart-container mx-auto bg-white" ref="chartContainer" v-init-vue></div>
  <p v-else class="text-center" v-init-vue>Es wurden noch keine Einnahmen generiert.</p>
</template>

<style scoped>
  .barchart-container {
    width: 760px;
    max-width: 100%;
    height: 300px;
  }
</style>